<script>
import { EstadoContador, EstadoRegistro, HOSTSERVER, RegistroEstadoContador, Rol } from '@/constants/global';
import Utils from '@/functions/utils';
import DataTable from 'datatables.net-vue3';
import DataTablesLib from 'datatables.net';
import ButtonsHtml5 from 'datatables.net-buttons/js/buttons.html5'
import pdfmake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import 'datatables.net-responsive-bs5';
import 'datatables.net-buttons/js/buttons.colVis';
import JsZip from 'jszip';
import authService from '@/services/auth.service';
window.JSZip = JsZip;

DataTable.use(DataTablesLib);
DataTable.use(pdfmake);
DataTable.use(ButtonsHtml5);

export default {
  components: {
    DataTable
  },
  data() {
    let usuario = authService.getUser();
    return {
      tblAjax:{
        url: `${HOSTSERVER}/api/v1/contadores`,
        headers: {
          'Authorization': `Bearer ${authService.getToken()}`,
        },
        dataSrc: 'data',
        data: (filters) => {
          
          const size = filters.length != -1 ? filters.length : 100000;
          let ordenable = filters.order[0] ?? {column: 0, dir:"desc"};
          let column = filters.columns[ordenable.column];
          return {
            page: ((size + filters.start) / size) - 1,
            filtro: filters.search.value ?? '',
            size: size,
            estado: EstadoRegistro.ACTIVO,
            idAsesor: usuario.rol == Rol.VENTAS ? usuario.idUsuario : 0,
            ocupacion: 'Contador',
            tipo: 0,
            order: column.data ?? 'id',
            dir: ordenable.dir
          }
        },
        dataFilter: (obj) => {
          //asignar los datos necesario
          let json = JSON.parse(obj);
          let recordsFiltered = json.count;
          let recordsTotal = json.count;
          let data = json.data

          let dataObj = { data, recordsFiltered, recordsTotal};

          return JSON.stringify(dataObj);
        }
      },
      tblValues: [],
      tblColumns: [
        { data: "id" },
        { data: "documento" },
        { data: "razonSocial" },
        {
          data: null, "render": function (data) {
            return data.asesorDesc || '-';
          }
        },
        { data: "ciudad" },
        { data: "direccion" },
        { data: "telefono" },
        { data: "correo" },
        {
          data: null, "render": function (data) {
            switch (data.estado) {
              case EstadoContador.PENDIENTE:
                return 'Pendiente'
              case EstadoContador.REGISTRADO:
                return 'Registrado'
              case EstadoContador.CANCELADO:
                return 'Cancelado'
              default:
                return 'Sin Estado'
            }
          }
        },
        {
          data: null, "render": function (data) {
            switch (data.confirmacion) {
              case RegistroEstadoContador.PENDIENTE:
                return 'Pendiente'
              case RegistroEstadoContador.CONFIRMADO:
                return 'Confirmado'
              default:
                return 'Sin Confirmación'
            }
          }
        },
        {
          data: null, "render": function (data) {
            return data.fechaCreacion
              ? Utils.formatFecha(data.fechaCreacion,'yyyy-MM-dd - HH:mm')
              : " - "
          }
        },
        {
          data: null, "render": function (data) {
            return data.fechaRegistro
              ? Utils.formatFecha(data.fechaRegistro,'yyyy-MM-dd - HH:mm')
              : " - "
          }
        },
        {
          data: null, "render": function (data) {
            return data.fechaConfirmacion
              ? Utils.formatFecha(data.fechaConfirmacion,'yyyy-MM-dd - HH:mm')
              : " - "
          }
        },
        {
          data: null, "render": function (data) {
            return `
            <a href="/contadores/edicion/${data.id}" class="btn btn-outline-primary">
              <i class="fas fa-edit"></i>
            </a>`;
          }
        },
      ],
      tblOptions: {
        processing: true,
        serverSide: true,
        order: [[0, "desc"]],
        pageLength: 5,
        lengthMenu: [[5, 10, 20, -1], [5, 10, 20, 'Todos']],
        language: {
          url: "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Spanish.json"
        },
        dom: 'Blfrtip',
        buttons: [{
          extend: 'excelHtml5',
          title: 'Tabla de Datos',
          messageBottom: 'Esta informacion es de propiedad de SmartClic.pe',
          autoFilter: true,
          sheetName: 'Datos exportados',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
          }
        },
        {
          extend: 'pdfHtml5',
          title: 'Tabla de Datos',
          messageBottom: 'Esta informacion es de propiedad de SmartClic.pe',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
          }
        },
        {
          extend: 'colvis',
          text: 'Ver Columnas',
          postfixButtons: ['colvisRestore'],
        }],
        columnDefs: [
          {
            targets: [-7, -8, -9, -10],
            visible: false,
          }
        ],
        responsive: false,
        autoWidth: false,
        scrollX: true
      }
    }
  }
}

</script>
<template>
  <div id="contadores" class="pestana">
    <div class="mb-3">
      <RouterLink to="/contadores/nuevo" class="btn btn-success"><i class="fas fa-plus-square"> Nuevo
          Contador</i></RouterLink>
    </div>
    <DataTable id="contadTable" class="table table-striped align-middle text-center mt-4" 
      :ajax="tblAjax"
      :data="tblValues"
      :columns="tblColumns" :options="tblOptions">
      <thead>
        <tr class="bg-primary text-white">
          <th scope="col">ID</th>
          <th scope="col">DNI</th>
          <th scope="col">Nombre</th>
          <th scope="col">Asesor</th>
          <th scope="col">Ciudad</th>
          <th scope="col">Dirección</th>
          <th scope="col">Teléfono</th>
          <th scope="col">E-mail</th>
          <th scope="col">Estado</th>
          <th scope="col">Confirmación</th>
          <th scope="col">Fecha Creación</th>
          <th scope="col">Fecha Registro</th>
          <th scope="col">Fecha Confirmación</th>
          <th scope="col" class="col-sm-2">Editar</th>
        </tr>
      </thead>
    </DataTable>
  </div>
</template>